<script>
    import { slide } from 'svelte/transition';

    export let item;

</script>

<div
    transition:slide
    class="ghwp-accordion__item-content ghwp-collapsible-panel"
>
    {@html item.content}
</div>
